import _ from 'underscore';
import { mapState } from 'vuex';

export default {
	name: 'earning_preview',
	props: {
		earning : Object
	},

	components : {
		
	},

	data : function(){

		return {}

	},

	created() {
		

	},

	destroyed() {
	},

	watch: {
		
	},
	computed: mapState({
		
		auth : state => state.auth,

		
	}),

	methods : {

	},
}